enum CouponProvider {
  None = 'none',
  Pos = 'pos',
  Loyalty = 'loyalty',
  Bite = 'bite',
}

export { CouponProvider };
